import {
  Card,
  CardBody,
  Row,
  Spin,
  Wrapper
} from "app/NativeComponents/common";
import { CardLabel } from "app/NativeComponents/snippets";
import React, { useState } from "react";
import { ChurnReport } from "./ChurnReport";
import { RevenueReport } from "./RevenueReport";
import { UserReport } from "./UserReport";
import { useSelector } from "react-redux";
import api from "app/DealMachineCore/apis/DealMachineAPIV2";
import { useAsyncMemo } from "app/DealMachineCore/hooks/useAsyncMemo";
import { defaultAffiliateData } from "./index";

const dm_api = api.create();

export const PartnerReports = () => {
  const { token } = useSelector(state => state.auth);
  const [loading, setLoading] = useState(false);
  const affiliateData = useAsyncMemo(
    async () => {
      if (loading || !token) return defaultAffiliateData;
      setLoading(true);
      const response = await dm_api.getAffiliateDashboard({ token });
      setLoading(false);
      if (!response.data || response.data.error || !response.data.results)
        return defaultAffiliateData;
      return response.data.results;
    },
    [token],
    defaultAffiliateData
  );
  return (
    <Wrapper>
      <Card>
        <CardLabel
          title={"User Activity Report"}
          icon={"timeline"}
          hasButton={false}
          onPress={() => {}}
          hasBorder={true}
        />
        <CardBody style={{ height: 350 }}>
          {loading ? (
            <Row style={{ justifyContent: "center", height: "100%" }}>
              <Spin size="small" />
            </Row>
          ) : (
            <UserReport affiliateData={affiliateData} />
          )}
        </CardBody>
      </Card>
      <Card>
        <CardLabel
          title={"User Churn Report"}
          icon={"timeline"}
          hasButton={false}
          onPress={() => {}}
          hasBorder={true}
        />
        <CardBody style={{ height: 350 }}>
          {loading ? (
            <Row style={{ justifyContent: "center", height: "100%" }}>
              <Spin size="small" />
            </Row>
          ) : (
            <ChurnReport affiliateData={affiliateData} />
          )}
        </CardBody>
      </Card>
      <Card>
        <CardLabel
          title={"Monthly Payouts Report"}
          icon={"timeline"}
          hasButton={false}
          onPress={() => {}}
          hasBorder={true}
        />
        <CardBody style={{ height: 350 }}>
          {loading ? (
            <Row style={{ justifyContent: "center", height: "100%" }}>
              <Spin size="small" />
            </Row>
          ) : (
            <RevenueReport affiliateData={affiliateData} />
          )}
        </CardBody>
      </Card>
    </Wrapper>
  );
};
